/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/
import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getUserInfo, logout } from '../store/reducers/user/userAction';

const GuardedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const auth = getAuth();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
        
      const userInfoAction = await dispatch(getUserInfo());
      const userInfo = userInfoAction.payload;
      if (user && userInfo && Object.keys(userInfo).length > 0) {
         console.log('setAuthenticated',user);

        setAuthenticated(true);
      } else {
        setAuthenticated(false);
          dispatch(logout());
        navigate('/login')

      }
      setLoading(false);
    });

    return () => unsubscribe(); // Cleanup function
  }, [auth]); // Run effect when auth changes

  if (loading) {
    // Show loading indicator while checking auth state
    return <CircularProgress />;
  }

  return authenticated ? children : null;
};

export default GuardedRoute;
